import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Spinner } from "./ui";
import { isCorrectAppForRole, transferSessionToApp } from "../lib/roleRedirect";

type Props = {
  /** Class name for the loading/redirecting container */
  loadingClassName?: string;
};

export function RequireAuth({
  loadingClassName = "flex min-h-dvh items-center justify-center",
}: Props = {}) {
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    if (auth.status === "anonymous") {
      navigate("/login", {
        replace: true,
        state: { from: location.pathname + location.search },
      });
    }
  }, [auth.status, location.pathname, location.search, navigate]);

  // Role-based redirect: if authenticated user is in the wrong app, transfer them
  useEffect(() => {
    if (
      auth.status === "authenticated" &&
      auth.user &&
      !isCorrectAppForRole(auth.user.role)
    ) {
      setRedirecting(true);
      transferSessionToApp(auth.user.role);
    }
  }, [auth.status, auth.user]);

  if (auth.status === "loading" || redirecting) {
    return (
      <div className={loadingClassName}>
        <Spinner label={redirecting ? "Redirecting..." : "Loading..."} />
      </div>
    );
  }

  if (auth.status === "anonymous") {
    return (
      <div className={loadingClassName}>
        <Spinner label="Redirecting..." />
      </div>
    );
  }

  return <Outlet />;
}
